<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 354px;
  padding: 18px 0;
}

.lines {
  height: 300px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <div class="lines">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      myChart: {},
      name: '赋码趋势图',
      nameList: ['广西百色翠丰特色农产品有限责任公司', '广西百色盛泰和农业有限公司', '广西田阳新靖田农产品贸易有限公司', '广西田阳穗丰园农产品贸易有限公司', '广西田阳天穗农产品贸易有限公司', '田阳县蔬心特色农产品经营部', '广西田阳骄阳农产品贸易有限公司', '蔬心特色农产品经营部', '广西蔬心特色农产品经营部'],
      num: 0
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.lines .main'));
    const option = {
      title: {
        text: this.nameList[this.num],
        left: 'center',
        top: 10,
        textStyle: {
          color: '#fff'
        }
      },
      grid: { // 设置图表位置
        left: '15%',
        bottom: '10%',
        top: '22%'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#4797FA",
            width: 1,
            type: "solid"
          }
        }
      },
      series: [{
        data: [400, 603, 800, 731, 900, 1203, 1011, 803, 763, 930, 621, 321],
        type: 'line',
        stack: 'area',
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          normal: {
            width: 0
          }
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#FCC849'
            }, {
              offset: 0.8,
              color: '#FF8801'
            }], false),
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 10
          }
        },
        itemStyle: {
          normal: {
            color: '#FF8801'
          }
        }
      }]
    }
    this.myChart.setOption(option)
    const that = this;
    setInterval(function () {
      that.num++
      const option = {
        title: {
          text: that.nameList[that.num % that.nameList.length],
          left: 'center',
          top: 10,
          textStyle: {
            color: '#fff'
          }
        },
        grid: { // 设置图表位置
          left: '15%',
          bottom: '10%',
          top: '22%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#4797FA",
              width: 1,
              type: "solid"
            }
          }
        },
        series: [{
          data: [400, 603, 800, 731, 900, 1203, 1011, 803, 763, 930, 621, 321],
          type: 'line',
          stack: 'area',
          smooth: true,
          symbolSize: 0,
          lineStyle: {
            normal: {
              width: 0
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#FCC849'
              }, {
                offset: 0.8,
                color: '#FF8801'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          itemStyle: {
            normal: {
              color: '#FF8801'
            }
          }
        }]
      }
      that.myChart.setOption(option)
    }, 3000)

    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?5e62d2b8